import { render, staticRenderFns } from "./StudentSubjectUpload.vue?vue&type=template&id=7e7890e0&"
import script from "./StudentSubjectUpload.vue?vue&type=script&lang=ts&"
export * from "./StudentSubjectUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports